module.exports = __webpack_public_path__ + "static/img/contact.9de7ca22.png";